import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { HelmetProvider } from 'react-helmet-async';
import { NavigationProvider, useNavigation } from './context/NavigationContext';
import { SiteSettingsProvider } from './context/SiteSettingsContext';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Work from './pages/Work';
import About from './pages/About';
import Snippets from './pages/Snippets';
import CaseStudy from './pages/CaseStudy';
import './App.css';
import './Pages.css';

// Wrapper component to handle page transitions
function AnimatedRoutes() {
  const location = useLocation();
  
  // Create a key that only changes on major route changes, not on case study slug changes
  const getRouteKey = () => {
    const pathSegments = location.pathname.split('/');
    if (pathSegments[1] === 'case-study') {
      return 'case-study'; // Same key for all case studies
    }
    return location.pathname; // Different key for other routes
  };
  
  return (
    <AnimatePresence 
      mode="sync"
      initial={false} // Prevent initial animation
      onExitComplete={() => window.scrollTo(0, 0)} // Reset scroll position
    >
      <Routes location={location} key={getRouteKey()}>
        <Route path="/" element={<Home />} />
        <Route path="/work" element={<Work />} />
        <Route path="/about" element={<About />} />
        <Route path="/snippets" element={<Snippets />} />
        <Route path="/case-study/:slug" element={<CaseStudy />} />
      </Routes>
    </AnimatePresence>
  );
}

// Component to provide navigate function to context
function NavigationSetup() {
  const navigate = useNavigate();
  const { setNavigate } = useNavigation();
  
  // Set the navigate function in the context
  setNavigate(navigate);
  
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <SiteSettingsProvider>
        <Router>
          <NavigationProvider>
            <NavigationSetup />
            <div className="App">
              <Navbar />
              <div className="page-container">
                <AnimatedRoutes />
              </div>
            </div>
          </NavigationProvider>
        </Router>
      </SiteSettingsProvider>
    </HelmetProvider>
  );
}

export default App;